export const TABLE_PAGE_DEFAULT = 0;

// for example if in leave request table more than 9 requests, rest ones would be paginated
export const PAGE_SIZE = 9;
